import GameModel from "../../GameModel";
import { Settings } from "../../Settings";
import { DawnBringerPalette } from "../color/DawnBringerPalette";
import FlickeringLightSourceCache from "./FlickeringLightSourceCache";
import LightSourceCache from "./LightSourceCache";
import LightSourceCreator from "./LightSourceCreator";

export default class LightSourceCreators extends GameModel {
    constructor() {
        super();

        const radius = Settings.lighting.lightSourceRadius;

        /**
         * @constant
         * @type {LightSourceCache}
         */
        this.lightSourceCache = new LightSourceCache();
        /**
         * @constant
         * @type {LightSourceCache}
         */
        this.flickeringLightSourceCache = new FlickeringLightSourceCache();


        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.lightGreenFlickering = new LightSourceCreator(DawnBringerPalette.LIGHT_GREEN, radius, this.flickeringLightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.darkGreenFlickering = new LightSourceCreator(DawnBringerPalette.DARK_GREEN, radius, this.flickeringLightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.cyanFlickering = new LightSourceCreator(DawnBringerPalette.CYAN, radius, this.flickeringLightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.orangeFlickering = new LightSourceCreator(DawnBringerPalette.ORANGE, radius, this.flickeringLightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.yellowFlickering = new LightSourceCreator(DawnBringerPalette.YELLOW, radius, this.flickeringLightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.peachFlickering = new LightSourceCreator(DawnBringerPalette.PEACH, radius, this.flickeringLightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.lightBlueFlickering = new LightSourceCreator(DawnBringerPalette.LIGHT_BLUE, radius, this.flickeringLightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.darkBlueFlickering = new LightSourceCreator(DawnBringerPalette.DARK_BLUE, radius, this.flickeringLightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.whiteFlickering = new LightSourceCreator(DawnBringerPalette.WHITE, radius, this.flickeringLightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.redFlickering = new LightSourceCreator(DawnBringerPalette.RED, radius, this.flickeringLightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.darkRedFlickering = new LightSourceCreator(DawnBringerPalette.DARK_RED, radius, this.flickeringLightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.lightGrayFlickering = new LightSourceCreator(DawnBringerPalette.LIGHT_GRAY, radius, this.flickeringLightSourceCache);


        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.lightGreen = new LightSourceCreator(DawnBringerPalette.LIGHT_GREEN, radius, this.lightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.darkGreen = new LightSourceCreator(DawnBringerPalette.DARK_GREEN, radius, this.lightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.cyan = new LightSourceCreator(DawnBringerPalette.CYAN, radius, this.lightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.orange = new LightSourceCreator(DawnBringerPalette.ORANGE, radius, this.lightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.yellow = new LightSourceCreator(DawnBringerPalette.YELLOW, radius, this.lightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.peach = new LightSourceCreator(DawnBringerPalette.PEACH, radius, this.lightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.lightBlue = new LightSourceCreator(DawnBringerPalette.LIGHT_BLUE, radius, this.lightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.darkBlue = new LightSourceCreator(DawnBringerPalette.DARK_BLUE, radius, this.lightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.white = new LightSourceCreator(DawnBringerPalette.WHITE, radius, this.lightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.red = new LightSourceCreator(DawnBringerPalette.RED, radius, this.lightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.darkRed = new LightSourceCreator(DawnBringerPalette.DARK_RED, radius, this.lightSourceCache);
        /**
         * @constant
         * @type {LightSourceCreator}
         */
        this.lightGray = new LightSourceCreator(DawnBringerPalette.LIGHT_GRAY, radius, this.lightSourceCache);
    
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        this.lightSourceCache.resetCache();
        this.flickeringLightSourceCache.resetCache();
    }

    /**
     * @override
     */
    resetForPrestige() {
        this.resetFull();
    }

}